import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'xemex-card-grid',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="grid grid-cols-1 md:grid-cols-2 items-start gap-6 has-[>:only-child]:flex has-[>:only-child]:justify-center [&>:only-child]:w-3/4"
    >
      <ng-content />
    </div>
  `,
})
export class CardGridComponent {}
